import { h } from '@stencil/core';
import cn from 'classnames';
import { isEmpty } from '@pes-ui/utils';
export class ProductPrice {
  constructor() {
    this.price = undefined;
    this.currency = undefined;
    this.info = undefined;
    this.isMobile = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    var _a;
    return (h("p", { class: cn('price', this.isMobile && 'price--mobile') }, h("span", null, this.price), h("span", { class: "currency" }, this.currency), ((_a = this.info) === null || _a === void 0 ? void 0 : _a.weeePrices) && !isEmpty(this.info.weeePrices) && h("slot", { name: "modal-tooltip" })));
  }
  static get is() { return "pes-product-price"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-product-price.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-product-price.css"]
    };
  }
  static get properties() {
    return {
      "price": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "price",
        "reflect": false
      },
      "currency": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "currency",
        "reflect": false
      },
      "info": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "{\n    weeePrices?: ProductInfoApi.WEEEPrices;\n  }",
          "resolved": "{ weeePrices?: WEEEPrices; }",
          "references": {
            "ProductInfoApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isMobile": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-mobile",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get elementRef() { return "el"; }
}
